import { render } from "./AreaCodePhoneNumberInput.vue?vue&type=template&id=70eac7e0&scoped=true"
import script from "./AreaCodePhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./AreaCodePhoneNumberInput.vue?vue&type=script&lang=js"

import "./AreaCodePhoneNumberInput.vue?vue&type=style&index=0&id=70eac7e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70eac7e0"]])

export default __exports__